import React from "react";
import { Link } from "react-router-dom";
import Button from "../FormElement/Button";
import { isAuthorized } from "./CheckAuthorization";

const nonAuthCreate = ["Commodities", "On site storage"];

const TabHeaderAndButton = ({
  header,
  path,
  btnLabel,
  isDisabled,
  isVisible = true,
  searchField = null
}) => {
  return (
    <div className="flex-display ticket-header">
      <h3 className="mainHeading">{header}</h3>
      {searchField}
      {!nonAuthCreate.includes(header) &&
        (isAuthorized() || header === "Tickets") &&
        isVisible && (
          <Link to={path}>
            <Button name={btnLabel} disabled={isDisabled} />
          </Link>
        )}
    </div>
  );
};

export default TabHeaderAndButton;



// WEBPACK FOOTER //
// ./src/components/Common/TabHeaderAndButton.js